const data = {
  id: 1,
  title: 'Listen and choose the word that has the correct stressed syllable',
  subTitle: 'Nghe và chọn từ được đánh trọng âm đúng',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/5b8729a3-0a0a-49c0-8b6a-a8ca09e58a01.mp3',
  answers: [
    { id: 1, answer: 'ca’rrot', isCorrect: false },
    { id: 2, answer: '’carrot', isCorrect: true },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
